var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"App"}},[_c('core-app-bar',{class:this.$vuetify.breakpoint.name!='sm'&
                          this.$vuetify.breakpoint.name!='xs'?"barset":""}),_c('core-view'),_c('core-footer'),_c('whatsapp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }